// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"138":"css/app.6722","3396":"css/admin-app.6722"}[chunkId] + ".css";
};